import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import { TwinChargerData } from "src/app/_models/location/TwinCharger";
import { TwinChargerDataDto } from "src/app/_models/location/LocationDTO";

type TwinChargerDataMap = { id_location: number; data: TwinChargerData[] };

export const SignalTwinChargerDataStore =
  new SignalStoreBuilder<TwinChargerDataMap>(
    (entry) => entry.id_location,
    (json) => {
      const id = json["id_location"] as number;
      const data = (json["data"] as unknown[]).map((d) =>
        TwinChargerData.fromDto(TwinChargerDataDto.fromJson(d)),
      );
      return { id_location: id, data };
    },
  )
    .withMethod("loadAllLatest", (_store, http, { upsert }) => async () => {
      const response = await http.get("location/twinChargers/data", {
        hideLoader: true,
      });
      if (!response) return;
      for (const item of response as any as {
        id_location: number;
        data: unknown;
      }[]) {
        if (!item.data) continue;
        const incoming = TwinChargerData.fromDto(
          TwinChargerDataDto.fromJson(item.data),
        );
        const existing = _store.entityMap()[item.id_location]?.data ?? [];
        upsert({
          id_location: item.id_location,
          data: [
            incoming,
            ...existing.filter(
              (d) => d.id_twincharger_data !== incoming.id_twincharger_data,
            ),
          ],
        });
      }
    })
    .withMethod(
      "loadData",
      (_store, http, { upsert }) =>
        async (id_location: number, limit: number = 120) => {
          const response = await http.get(
            `location/twinChargers/${id_location}/data?limit=${limit}`,
            { hideLoader: true },
          );
          if (!response) return;
          const data = (response["data"] as unknown[]).map((d) =>
            TwinChargerData.fromDto(TwinChargerDataDto.fromJson(d)),
          );
          upsert({ id_location, data });
        },
    )
    .withMethod(
      "loadLatest",
      (_store, http, { upsert }) =>
        async (id_location: number) => {
          const response = await http.get(
            `location/twinChargers/${id_location}/data?limit=1`,
            { hideLoader: true },
          );
          if (!response) return;
          const incoming = (response["data"] as unknown[]).map((d) =>
            TwinChargerData.fromDto(TwinChargerDataDto.fromJson(d)),
          );
          const existing = _store.entityMap()[id_location]?.data ?? [];
          const merged = [
            ...incoming,
            ...existing.filter(
              (e) =>
                !incoming.some(
                  (i) => i.id_twincharger_data === e.id_twincharger_data,
                ),
            ),
          ];
          upsert({ id_location, data: merged });
        },
    )
    .withAutoRefresh((store) => store.loadAllLatest())
    .providedInRoot()
    .build();
